import { render, staticRenderFns } from "./restaurantMenuListTable.vue?vue&type=template&id=7c54a9ba&"
import script from "./restaurantMenuListTable.vue?vue&type=script&lang=js&"
export * from "./restaurantMenuListTable.vue?vue&type=script&lang=js&"
import style0 from "./restaurantMenuListTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports